import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection } from '@components'
import './InstituteProfile.scss'
import { ProfileBukopinAPI, BannerProfileAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import { Accordion, ThumbnailBig } from '../../../common/components'
import MenuProfile from '../MenuProfile'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const InstituteProfileContainer = styled.div`
  background-color: #fff;
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
    margin-top: 0;
  }
`

const Card = styled.div`
  height: auto;
  background: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 5%) 0px -1px 2px, rgb(0 0 0 / 10%) 0px 2px 4px;
  border-radius: 8px;
`

const CardTitle = styled.h3`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: rgb(94, 81, 77);
`

const TextMuted = styled.span`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 12px;
  line-height: 150%;
  color: rgb(138, 141, 143);
  margin-bottom: 6px;
`

const Text = styled.p`
  font-size: 16px;
  line-height: 150%;
  color: rgb(94, 81, 77);
  margin-bottom: 0px;
`

const Button = styled.a`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: rgb(0, 0, 0);
  background: rgb(242, 169, 0);
`

const Badge = styled.span`
  background: #edeeee;
  border-radius: 0px 12px;
  padding: 8px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 150%;
  color: #8a8d8f;
`

const InstituteProfile = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(false)

  useEffect(async () => {
    setisLoading(true)
    await getDesc()
    loadData()
  }, [])

  const getDesc = async function () {
    const { data } = await BannerProfileAPI({ loc: 'lembaga_penunjang' })
    setShortDesc(data.data[0])
  }
  const loadData = async function () {
    const { data } = await ProfileBukopinAPI('')
    setdata(data.data)
    setisLoading(false)
  }
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <ThumbnailBig
          title={isLoading ? '' : shortDesc.title}
          desc={isLoading ? '' : shortDesc.description}
          img={isLoading ? '' : shortDesc.banner}
        />
      </Container>

      <InstituteProfileContainer>
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12 me-3">
            {typeof data.dataBlockPenghargaan != 'undefined' &&
              data.dataBlockPenghargaan.length > 0 && (
                <div className="mb-5">
                  <div className="row">
                    {data.lambagaProfesi.map((item, index) => {
                      return (
                        <Card className="p-3 mb-3">
                          <Badge>{item.lableLembaga}</Badge>
                          <CardTitle className="my-3">
                            {item.nameLembaga}
                          </CardTitle>
                          <div className="mb-3">
                            <TextMuted>{t('Alamat')}</TextMuted>
                            <Text>{item.alamatLembaga}</Text>
                          </div>
                          <div className="d-flex flex-column flex-lg-row">
                            <div className="d-flex me-5 mb-3">
                              <svg
                                width="1.5em"
                                height="1.5em"
                                viewBox="0 0 24 24"
                                fill="#5e514d"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M10.857 8.338c.518-.698.704-1.434.118-2.084-1.315-1.84-2.2-2.978-2.754-3.525-1.055-1.042-2.79-.901-3.703-.001-.49.483-.657.649-1.16 1.16C.552 6.697 2.263 12.63 6.812 17.184c4.547 4.552 10.48 6.264 13.292 3.45.465-.447.859-.841 1.169-1.169.895-.946 1.03-2.604-.006-3.682-.532-.552-1.617-1.393-3.534-2.765-.587-.525-1.284-.411-1.922.007-.307.202-.53.406-.952.828l-.767.767c-.1.1-1.47-.586-2.801-1.917C9.96 11.37 9.274 9.999 9.374 9.899l.767-.768c.134-.134.198-.198.28-.285.171-.18.313-.343.436-.508zm4.649 7.695l.766-.767a6.86 6.86 0 01.505-.474c1.68 1.206 2.653 1.965 3.05 2.378.239.248.202.7-.006.919-.287.303-.66.677-1.117 1.118-1.818 1.819-6.608.437-10.479-3.438-3.872-3.876-5.253-8.666-3.449-10.472.502-.509.66-.668 1.144-1.144.182-.179.676-.22.896-.001.427.422 1.22 1.436 2.385 3.06-.06.074-.136.159-.228.255-.067.071-.123.128-.246.25l-.766.767c-1.303 1.303-.193 3.52 1.916 5.632 2.108 2.11 4.326 3.22 5.629 1.917z"
                                ></path>
                              </svg>
                              <Text className="ms-2">{item.phoneLembaga}</Text>
                            </div>
                            <div className="d-flex mb-3">
                              <svg
                                width="1.5em"
                                height="1.5em"
                                viewBox="0 0 24 24"
                                fill="#5e514d"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M4 7h2V2h12v5h2a2 2 0 012 2v8a2 2 0 01-2 2h-2v3H6v-3H4a2 2 0 01-2-2V9a2 2 0 012-2zm12 0H8V4h8v3zm4 2v8h-2v-2H6v2H4V9h16zm-4 8H8v3h8v-3zm3-6a1 1 0 10-2 0 1 1 0 002 0z"
                                ></path>
                              </svg>
                              <Text className="ms-2">{item.faxLembaga}</Text>
                            </div>
                          </div>
                          <div className="d-grid">
                            <a
                              type="button"
                              target={'_blank'}
                              href={
                                `${item.webLembaga}`.includes('http')
                                  ? item.webLembaga
                                  : `https://${item.webLembaga}`
                              }
                              className="btn btn-primary btn-lg"
                            >
                              {t('KunjungiWebsite')}
                              <svg
                                className="ms-2 mb-1"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="black"
                                class="bi bi-box-arrow-up-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                                />
                                <path
                                  fill-rule="evenodd"
                                  d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                                />
                              </svg>
                            </a>
                          </div>
                        </Card>
                      )
                    })}
                  </div>
                </div>
              )}
          </div>
          <div className="d-none d-lg-block col">
            <MenuProfile active={7} />
          </div>
        </div>
      </InstituteProfileContainer>
      <FooterSection currentPage={t('lembaga_profesi_perusahaan')} />
    </div>
  )
}

export default InstituteProfile
